import { UpperCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { WahldividendeBase } from '../wahldividende.base';

@Component({
  imports: [TranslocoPipe, RouterLink, LottieComponent, ButtonComponent, UpperCasePipe],
  templateUrl: './wahldividende-success.component.html',
  styleUrls: ['./wahldividende-success.component.scss'],
})
export class WahldividendeSuccessComponent extends WahldividendeBase {
  public options: AnimationOptions = {
    path: '/assets/animatedgraphics/checkmark-update.json',
    loop: false,
  };
}
